import React from 'react';
import { Input } from 'reactstrap';
import radioChecked from '../../../assets/images/radio-checked.svg';
import radioUnChecked from '../../../assets/images/radio-unchecked.svg';


const RadioButton = ({radioList, selectedPlanType, onClickRadio,personalisedImg}) => {
  return (
    <>
      {
        radioList.map(option => (
          <label style={{width:'95%', margin:'auto'}} key={option.value} className={`assessment-checkbox mb-4 ${option.value === selectedPlanType && 'assessment-checkbox-border'}`} htmlFor={option.value}>
                            <img src={personalisedImg} alt='' />
            
            <span className='payment-option-title' style={{alignSelf:'center' }} htmlFor={option.value}>{option.planType}</span>
            <span className='payment-discount-price' style={{marginLeft:'75px',alignSelf:'center' }} htmlFor={option.price}>{option.price}</span>
            <Input 
              type='radio' 
              className='float-end mt-0 invisible'
              id={option.value}
              value={option.value}
              checked={selectedPlanType === option.value}
              onChange={(e) => onClickRadio(e)}
            />

              <img src={option.value === selectedPlanType ? radioChecked : radioUnChecked} alt=''  />
          </label>
        ))
      }
    </>
  );
}

export default RadioButton;